import React, { useState, ChangeEvent, useEffect } from 'react'
import { formatSum } from '../../../../../utils/formatSum'
import { KTIcon } from '../../../../../_metronic/helpers'

interface AmountInputProps {
  initialAmount: number | null
  onAccept: (amount: number) => void
  expectedAmount: number | null
  fetching: boolean
  isUnlimChange: boolean
  requisiteAmount: number | null | undefined
  /** Заблокировать ввод (напр. по тикету открыт диспут — сумму менять нельзя, CPAYMENT-1615). */
  disabled?: boolean
  /** Подпись под ячейкой — бейдж «было → стало» (CPAYMENT-1669). */
  footer?: React.ReactNode
}

export const AmountInputCell: React.FC<AmountInputProps> = ({ initialAmount, onAccept, expectedAmount, fetching, isUnlimChange, requisiteAmount, disabled = false, footer }) => {
  const [amount, setAmount] = useState<string>(initialAmount ? initialAmount.toString() : "")
  const [edited, setEdited] = useState(false)

  const isInvalid = amount === '' || parseFloat(amount) <= 0 || (!isUnlimChange && parseFloat(amount) >= 100000)

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    if (value === '' || parseFloat(value) < 100000 || isUnlimChange) {
      setAmount(value)
      setEdited(value !== '')
    }
  }

  const handleAccept = () => {
    if (!isInvalid && amount !== '') {
      onAccept(parseFloat(amount))
      setEdited(false)
    }
  }

  useEffect(() => {
    if (requisiteAmount !== null || expectedAmount !== null) {
      setAmount('')
    }
  }, [requisiteAmount, expectedAmount])

  return (
    <td>
      <div className="flex items-center gap-1">
        {initialAmount ? (
          <span>{formatSum(initialAmount)}</span>
        ) : (
          <>
            <input
              className={`border border-${edited ? isInvalid ? 'danger' : 'success' : 'warning'} rounded p-1`}
              type="number"
              min={0.1}
              max={!isUnlimChange ? 99999.99 : undefined}
              required
              value={amount}
              disabled={fetching || disabled}
              onChange={handleChange}
              placeholder={`${formatSum(requisiteAmount || expectedAmount || 0)}`}
              style={{ width: '100px', color: '#000' }}
            />
            {!disabled && ((edited && !isInvalid) || fetching) ? (
              <button
                type="button"
                onClick={handleAccept}
                className="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1 me-4"
                title="Подтвердить сумму"
                disabled={fetching || isInvalid}
              >
                {fetching ? (
                  <KTIcon className="fs-1 spinner" iconName="loading" />
                ) : (
                  <KTIcon className="fs-1" iconName="check-circle" />
                )}
              </button>
            ) : null}
          </>
        )}
      </div>
      {footer}
    </td>
  )
}
